import styled from 'styled-components';
import { StyledGrid } from '@tryhackme/thm-ui-components';

export const StyledGridWrapper = styled(StyledGrid)`
  margin: 2.4rem 0;
  > span[data-type='select'] {
    margin-bottom: 2.2rem;
  }
  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1fr;
  }
`;

export const StyledButtonsWrapper = styled.div`
  background: ${({ theme }) => theme.colors.background.secondaryLight};
  padding: 2rem;
  border-radius: 0.5rem 0 0 0.5rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  p,
  a {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
  p {
    color: ${({ theme }) => theme.colors.grey[500]};
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    display: none;
  }
`;
